// extracted by mini-css-extract-plugin
export default {"loadingMessage":"loadingMessage---_TgvS","loadingMessageLabel":"loadingMessageLabel---jFs4L"};